exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".itpx-heading {\n    border-radius: 2px;\n    padding: 16px;\n    margin-bottom: 16px;\n    border: solid 1px #eee;\n    border-left: solid 4px #11A1E6 !important;\n}\n\n.itpx-heading > p,\n.itpx-heading > h2 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.header {\n    margin-bottom: 0;\n    color: #11A1E6;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-heading/happy-heading.component.css
// module id = 831
// module chunks = 0